export const TEST_DATA = [
  { id: 1, name: "Test 1", description: "Test 1 description" },
  { id: 2, name: "Test 2", description: "Test 2 description" },
  { id: 3, name: "Test 3", description: "Test 3 description" },
  { id: 4, name: "Test 4", description: "Test 4 description" },
  { id: 5, name: "Test 5", description: "Test 5 description" },
];
